import { OpenapiError } from '../shared/api/errors'

/**
 * Builds an `errorClass` predicate for user-auth mutations: labels the given codes, plus any
 * code-less error `isExpectedWithoutCode` accepts, as expected. Anything else stays unlabelled
 * so it still surfaces as a real error.
 */
export function userAuthErrorClass(codes: string[], isExpectedWithoutCode: (error: OpenapiError) => boolean) {
    return (error: unknown): 'expected' | undefined => {
        if (!OpenapiError.isError(error)) return undefined

        const isExpected = codes.includes(error.data?.code) || isExpectedWithoutCode(error)

        return isExpected ? 'expected' : undefined
    }
}
